import { Loader2 } from "@aircall/react-icons";
import { DynamicLoader } from "@/components/DynamicLoader/DynamicLoader";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout/PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout/PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle/PlaygroundSubSectionTitle";

const TRANSLATION_KEYS = [
  "Analyzing the conversation",
  "Summarizing key topics",
  "Detecting next actions",
];

export function PlaygroundDynamicLoader() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Basic Usage (default spinner, cycles every 3s)
        </PlaygroundSubSectionTitle>
        <div className="flex flex-wrap items-center gap-4">
          <DynamicLoader translationKeys={TRANSLATION_KEYS} />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Fast Interval (1s)
        </PlaygroundSubSectionTitle>
        <div className="flex flex-wrap items-center gap-4">
          <DynamicLoader
            translationKeys={TRANSLATION_KEYS}
            intervalTime={1000}
          />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Custom Loader Children
        </PlaygroundSubSectionTitle>
        <div className="flex flex-wrap items-center gap-4">
          <DynamicLoader translationKeys={TRANSLATION_KEYS}>
            <Loader2 className="size-10 animate-spin text-primary" />
          </DynamicLoader>
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Single Key (no cycling)
        </PlaygroundSubSectionTitle>
        <div className="flex flex-wrap items-center gap-4">
          <DynamicLoader translationKeys={["Loading"]} />
        </div>
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Custom className (constrained height, centered)
        </PlaygroundSubSectionTitle>
        <div className="flex flex-wrap items-center gap-4">
          <DynamicLoader
            translationKeys={TRANSLATION_KEYS}
            className="h-40 justify-center rounded-md bg-muted"
          />
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
